import React, {useContext, useState} from 'react';
import {Container, Form, FloatingLabel, Image, Button, Modal} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {HOME_ROUTE} from "../utils/const";
import {login, register, hasRole } from "../http/userAPI";
import {observer} from "mobx-react-lite";
import {Context} from "../index";
import '../css/login.css';
import logo from '../assets/logo_evo7.svg'
import nmb from '../assets/nmb_7.svg'
import slogan from '../assets/slogan_e7.svg'
import { toast } from "react-toastify";

const Auth = observer(({ barLineHeight }) => {
    const {user} = useContext(Context) // хз от антона осталось // Если используешь userContext то вернуть

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate(); // Инициализируем navigate
    const [showRegister, setShowRegister] = useState(false); // Состояние для модалки регистрации

        const handleLogin = async (e) => {
            e.preventDefault();
            
            if (!username || !password) {
              setError("Введите логин и пароль");
              return;
            }
        
            try {
              
                const userData = await login(username, password);
            //    console.log("Успешный вход:", userData);
                user.setUser(userData)
                user.setIsAuth(true)
                user.setToken(userData.token)
                   // ✅ Запрашиваем роли сразу после логина
                user.setHasRoleUserForSite(false)
                const [shop, opt] = await Promise.all([
                    hasRole("ROLE_SHOP"),
                    hasRole("ROLE_OPT"),
                  ]);
                  user.setHasRoleShop(shop);
                  user.setHasRoleOpt(opt);


                const returnTo = sessionStorage.getItem("returnTo");
                navigate(returnTo || HOME_ROUTE); // если нет — на главную
                sessionStorage.removeItem("returnTo"); // очистим после перехода                
                            } catch (err) {
                    setError("Неверный логин или пароль");
                }
            };

            // Состояния для регистрации..  надо делать!!!
    const [regData, setRegData] = useState({
        name: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        password: "",
        isInstaller: false,
        address: "",
        city: "" // сюда временно подгружается ИНН
    });
    const handleRegister = async (e) => {
        e.preventDefault();
        if (!regData.name || !regData.lastName || !regData.email || !regData.phoneNumber || !regData.password) {
            setError("Заполните все поля!");
            return;
        }
        try {
            const newUser = await register(regData);            
            setShowRegister(false); // Закрываем модалку после успешной регистрации
            user.setUser(newUser)
            user.setIsAuth(true)
            user.setToken(newUser.token) //сохраняется в методе
            toast.success("Регистрация прошла успешно!");
            const returnTo = sessionStorage.getItem("returnTo");
                navigate(returnTo || HOME_ROUTE); // если нет — на главную
                sessionStorage.removeItem("returnTo"); // очистим после перехода
        } catch (err) {
            setError("Ошибка при регистрации. Попробуйте позже.");
        }
    };

         
     return (
        <div 
            className="body-auth bg-dark"
            style={{
                minHeight: `calc(100vh - ${barLineHeight || 0}px)`, // Учитываем высоту барлайна
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}>
                <Image src={logo} className="logo_evo7" alt="logo"/>
                <Image src={nmb} className="nmb_evo7" alt="nmb_evo7"/>
                <Image src={slogan} className="slogan_evo7" alt="slogan_evo7"/>
                
            <Container
                className="text-center"
            >
                <div className="form-signin w-100 m-auto">
                    <Form onSubmit={handleLogin}
                          style={{marginTop: "200px" }}>                                 
                        <FloatingLabel className="mb-4" label="Email address">
                            <Form.Control
                                className="rounded-4 border border-0"
                                placeholder="Введите ваш email..."
                                value={username}
                                onChange={e => setUsername(e.target.value)}
                                style={{backgroundColor: "rgba(255, 255, 255, 0.8)"}}
                            />
                        </FloatingLabel>
                        <FloatingLabel className="mb-4" label="Password">
                            <Form.Control
                                className="form-control rounded-4 border border-0"
                                placeholder="Введите ваш пароль..."
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                type="password"
                                style={{backgroundColor: "rgba(255, 255, 255, 0.8)"}}
                            />
                        </FloatingLabel>
                        <FloatingLabel>
                            {error && <div className="error-message text-danger">{error}</div>} 
                                <Button
                                    variant={"primary"}
                                    className="login-button w-100 btn-lg rounded-4 border border-0 "
                                    // variant={"outline-success"}
                                    type="submit"                                    
                                >  Войти
                                </Button>
                                <Button
                                    variant="outline-light"
                                    className="mt-3 w-100 btn-lg rounded-4"
                                    onClick={() => setShowRegister(true)}>
                                    Регистрация
                                </Button>
                                </FloatingLabel>
                        </Form>
                    </div>
            </Container>

            {/* Модальное окно регистрации */}
            <Modal show={showRegister} onHide={() => setShowRegister(false)} centered bg="dark" data-bs-theme="dark">
                <Modal.Header closeButton>
                    <Modal.Title className="text-light">Регистрация</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-light">
                    <Form onSubmit={handleRegister}>
                        <FloatingLabel className="mb-3" label="Имя">
                            <Form.Control
                                type="text"
                                placeholder="Введите ваше имя"
                                className="text-light"
                                style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}
                                value={regData.name}
                                onChange={(e) => setRegData({ ...regData, name: e.target.value })}
                            />
                        </FloatingLabel>
                        <FloatingLabel className="mb-3" label="Фамилия">
                            <Form.Control
                                type="text"
                                placeholder="Введите вашу фамилию"
                                className="text-light"
                                style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}
                                value={regData.lastName}
                                onChange={(e) => setRegData({ ...regData, lastName: e.target.value })}
                            />
                        </FloatingLabel>
                        <FloatingLabel className="mb-3" label="Email">
                            <Form.Control
                                type="email"
                                placeholder="Введите ваш email"
                                className="text-light"
                                style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}
                                value={regData.email}
                                onChange={(e) => setRegData({ ...regData, email: e.target.value })}
                            />
                        </FloatingLabel>
                        <FloatingLabel className="mb-3" label="Номер телефона">
                            <Form.Control
                                type="tel"
                                placeholder="Введите ваш номер телефона"
                                className="text-light"
                                style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}
                                value={regData.phoneNumber}
                                onChange={(e) => setRegData({ ...regData, phoneNumber: e.target.value })}
                            />
                        </FloatingLabel>
                        <FloatingLabel className="mb-3" label="Пароль">
                            <Form.Control
                                type="password"
                                placeholder="Введите пароль"
                                className="text-light"
                                style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}
                                value={regData.password}
                                onChange={(e) => setRegData({ ...regData, password: e.target.value })}
                            />
                        </FloatingLabel>
                        <Form.Check
    type="checkbox"
    label="Монтажная организация"
    className="mb-3"
    checked={regData.isInstaller}
    onChange={(e) => setRegData({ ...regData, isInstaller: e.target.checked })}
/>

{regData.isInstaller && (
    <>
        <FloatingLabel className="mb-3" label="ИНН">
            <Form.Control
                type="text"
                placeholder="Введите ИНН"
                className="text-light"
                style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}
                value={regData.address || ""}
                onChange={(e) => setRegData({ ...regData, address: e.target.value })}
            />
        </FloatingLabel>
        <FloatingLabel className="mb-3" label="Города, где работает организация">
            <Form.Control
                type="text"
                placeholder="Например: Москва, Санкт-Петербург"
                className="text-light"
                style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}
                value={regData.city || ""}
                onChange={(e) => setRegData({ ...regData, city: e.target.value })}
            />
        </FloatingLabel>
    </>
)}
                        <Button variant="primary" className="login-button w-100 btn-lg rounded-4 border border-0" type="submit">
                            Зарегистрироваться
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>


            <p style={{
                position: "fixed",
                bottom: "10px", // Отступ от низа
                left: "50%", // Центрируем по горизонтали
                transform: "translateX(-50%)", // Смещаем на половину ширины
                textAlign: "center",
                width: "100%",
                color: "#fff" // Можно поменять цвет
                }}> &copy; 2023 - 2025</p>
        </div>
    );
});

export default Auth;